import { render, staticRenderFns } from "./FoodOrder.vue?vue&type=template&id=482c62d4&"
import script from "./FoodOrder.vue?vue&type=script&lang=js&"
export * from "./FoodOrder.vue?vue&type=script&lang=js&"
import style0 from "./FoodOrder.vue?vue&type=style&index=0&id=482c62d4&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports